module.exports = __webpack_public_path__ + "media/images/page/gift-about-05090cab98377bcbbb48d2b492142c07.jpg";